import React, { useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, MessageSquare, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setSent(true); toast.success("Message sent! We'll be in touch."); }
    catch { toast.error("Failed to send"); }
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12 grid lg:grid-cols-2 gap-12">
        <div>
          <h1 className="font-display text-4xl font-extrabold text-lawn-ink">Get in touch</h1>
          <p className="text-muted-foreground mt-2">Questions about bookings, providers, or partnerships? We're here to help.</p>
          <div className="mt-8 space-y-4">
            {[{ icon: Mail, t: "Email", d: "support@lawnlinkpro.com" }, { icon: Phone, t: "Phone", d: "(555) 123-LAWN" }, { icon: MessageSquare, t: "Live chat", d: "Use the AI Concierge, bottom right" }].map((c, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-xl bg-lawn-light flex items-center justify-center"><c.icon className="w-5 h-5 text-lawn-dark" /></div>
                <div><p className="font-semibold text-lawn-ink text-sm">{c.t}</p><p className="text-muted-foreground text-sm">{c.d}</p></div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          {sent ? (
            <div className="text-center py-12"><h3 className="font-display text-2xl font-bold text-lawn-ink">Thank you! 🌿</h3><p className="text-muted-foreground mt-2">We'll get back to you within 24 hours.</p></div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div><Label>Name</Label><Input data-testid="contact-name" value={form.name} onChange={set("name")} required className="mt-1.5 rounded-xl" /></div>
              <div><Label>Email</Label><Input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} required className="mt-1.5 rounded-xl" /></div>
              <div><Label>Subject</Label><Input data-testid="contact-subject" value={form.subject} onChange={set("subject")} className="mt-1.5 rounded-xl" /></div>
              <div><Label>Message</Label><Textarea data-testid="contact-message" value={form.message} onChange={set("message")} required rows={5} className="mt-1.5 rounded-xl" /></div>
              <Button data-testid="contact-submit" type="submit" className="w-full rounded-full bg-lawn hover:bg-lawn-dark font-semibold h-11">Send Message</Button>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
}
